import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

import { ProjectIdSchema } from '../unique-id.models.ts'
import { SurveyFeedbackSchema, SurveyRatingSchema } from './common.ts'
import { SurveyTypeSchema } from './survey-types.ts'

export const ProjectCompletedMakerReviewsBrandResponsesSchema = z.object({
  brandRating: SurveyRatingSchema,
  feedback: SurveyFeedbackSchema.optional(),
})

export const ProjectCompletedMakerReviewsBrandRatingFieldsSchema =
  ProjectCompletedMakerReviewsBrandResponsesSchema.pick({
    brandRating: true,
  }).keyof()

export type ProjectCompletedMakerReviewsBrandRatingField = ZodInfer<
  typeof ProjectCompletedMakerReviewsBrandRatingFieldsSchema
>

export type ProjectCompletedMakerReviewsBrandResponses = ZodInfer<
  typeof ProjectCompletedMakerReviewsBrandResponsesSchema
>

export const ProjectCompletedMakerReviewsBrandSurveyDetailsSchema = z.object({
  surveyType: SurveyTypeSchema.extract([
    'project-completed-maker-reviews-brand',
  ]),
  projectId: ProjectIdSchema,
  responses: ProjectCompletedMakerReviewsBrandResponsesSchema,
})
